var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.912 8.14844H12.6539V14.0405C12.6539 14.2129 12.5849 14.3783 12.4621 14.5002C12.3392 14.6221 12.1726 14.6906 11.9989 14.6906C11.8251 14.6906 11.6585 14.6221 11.5356 14.5002C11.4128 14.3783 11.3438 14.2129 11.3438 14.0405V8.14844H7.08575C6.47787 8.14908 5.89507 8.38903 5.46523 8.81564C5.03539 9.24225 4.79362 9.82067 4.79297 10.424V18.2258C4.79362 18.8292 5.03539 19.4076 5.46523 19.8342C5.89507 20.2608 6.47787 20.5007 7.08575 20.5014H16.912C17.5198 20.5007 18.1026 20.2608 18.5325 19.8342C18.9623 19.4076 19.2041 18.8292 19.2047 18.2258V10.424C19.2041 9.82067 18.9623 9.24225 18.5325 8.81564C18.1026 8.38903 17.5198 8.14908 16.912 8.14844Z",
    fill: "#333D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5817 4.988L14.5051 6.9053C14.6155 7.0099 14.7626 7.06735 14.9149 7.0654C15.0671 7.06346 15.2127 7.00227 15.3204 6.89489C15.4281 6.78751 15.4894 6.64243 15.4914 6.49058C15.4933 6.33874 15.4357 6.19214 15.3308 6.08204L12.4105 3.17042C12.301 3.0613 12.1525 3 11.9977 3C11.8428 3 11.6943 3.0613 11.5848 3.17042L8.66453 6.08204C8.55963 6.19214 8.502 6.33874 8.50395 6.49058C8.5059 6.64243 8.56727 6.78751 8.67497 6.89489C8.78267 7.00227 8.92819 7.06346 9.08048 7.0654C9.23278 7.06735 9.37982 7.0099 9.49024 6.9053L11.4136 4.988V8.24064H12.5817V4.988Z",
    fill: "#333D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.8d5f91c57852f1745ff7dd15605ac439.svg";
export { ForwardRef as ReactComponent };